import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { SiteProvider } from "./lib/site";
import { CartProvider } from "./lib/cart";
import { AdminAuthProvider } from "./admin/AdminAuth";

import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import DynamicPage from "./pages/DynamicPage";
import ItemDetail from "./pages/ItemDetail";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirm from "./pages/OrderConfirm";
import Enquire from "./pages/Enquire";
import Builds from "./pages/Builds";
import Blog from "./pages/Blog";
import SiteIndex from "./pages/SiteIndex";
import Search from "./pages/Search";
import NewVehicleBuild from "./pages/NewVehicleBuild";
import RacexTownsville from "./pages/RacexTownsville";
import Returns from "./pages/policies/Returns";
import Shipping from "./pages/policies/Shipping";
import Terms from "./pages/policies/Terms";
import Privacy from "./pages/policies/Privacy";

import AdminRoutes from "./admin/AdminRoutes";
import { initAnalytics, trackPageChange } from "./lib/analytics";
import CookieNotice from "./components/CookieNotice";

function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order/:id" element={<OrderConfirm />} />
        <Route path="/enquire" element={<Enquire />} />
        <Route path="/item/:id" element={<ItemDetail />} />
        <Route path="/our-builds" element={<Builds />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/site-index" element={<SiteIndex />} />
        <Route path="/search" element={<Search />} />
        <Route path="/new-vehicle-build" element={<NewVehicleBuild />} />
        <Route path="/returns-refunds" element={<Returns />} />
        <Route path="/shipping-delivery" element={<Shipping />} />
        <Route path="/terms-of-sale" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        {/* every other migrated page (including nested blog post slugs) */}
        <Route path="*" element={<DynamicPage />} />
      </Routes>
    </Layout>
  );
}

function PageChangeTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageChange(pathname);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageChangeTracker />
        <SiteProvider>
          <CartProvider>
            <AdminAuthProvider>
              <Routes>
                <Route path="/admin/*" element={<AdminRoutes />} />
                <Route path="/racex-townsville" element={<RacexTownsville />} />
                <Route path="*" element={<PublicSite />} />
              </Routes>
            </AdminAuthProvider>
          </CartProvider>
          <CookieNotice />
        </SiteProvider>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#111513",
              border: "1px solid rgba(198,162,74,0.3)",
              color: "#E9E2D2",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}
